import { FormattedMessage, useIntl } from 'react-intl';

import { Alert, Box, Button, Typography } from '@evaneos/b2b-ui';
import RefreshIcon from '@evaneos/b2b-ui/icons/Refresh';

type TranscriptTabProps = {
    transcript: string | null;
    isTranscriptDeleted: boolean;
    hasTranscriptError: boolean;
    canRegenerate: boolean;
    isRegenerating: boolean;
    onRegenerate: () => void;
};

export const TranscriptTab = ({
    transcript,
    isTranscriptDeleted,
    hasTranscriptError,
    canRegenerate,
    isRegenerating,
    onRegenerate,
}: TranscriptTabProps) => {
    const { formatMessage } = useIntl();

    return (
        <Box>
            {isTranscriptDeleted ? (
                <Alert severity="info" sx={{ mb: 2 }}>
                    <FormattedMessage id="dossier.discussion.phone_call.transcript_deleted" />
                </Alert>
            ) : (
                hasTranscriptError && (
                    <Alert
                        severity="error"
                        sx={{ mb: 2, border: '1px solid', borderColor: 'error.dark' }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: 'inherit', fontWeight: 'bold', marginBottom: 0.5 }}
                        >
                            {formatMessage({
                                id: 'dossier.discussion.phone_call.transcript.error.not_available.title',
                            })}
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'inherit', marginBottom: 1.5 }}>
                            {formatMessage({
                                id: 'dossier.discussion.phone_call.transcript.error.not_available.message',
                            })}
                        </Typography>
                        {canRegenerate && (
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<RefreshIcon />}
                                onClick={onRegenerate}
                                disabled={isRegenerating}
                            >
                                {formatMessage({
                                    id: 'dossier.discussion.phone_call.regeneration.transcript.button',
                                })}
                            </Button>
                        )}
                    </Alert>
                )
            )}
            {transcript?.split('\n').map((line, index) => (
                <Typography key={`transcript-line-${index}`} sx={{ mb: 1 }} variant="body2">
                    {line}
                </Typography>
            ))}
            {!hasTranscriptError && canRegenerate && (
                <Box
                    sx={{
                        marginTop: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        paddingTop: 2,
                    }}
                >
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<RefreshIcon />}
                        onClick={onRegenerate}
                        disabled={isRegenerating}
                    >
                        {formatMessage({
                            id: 'dossier.discussion.phone_call.regeneration.transcript.button',
                        })}
                    </Button>
                </Box>
            )}
        </Box>
    );
};
